import React, { useState } from 'react';
import './App.css';
import RoiCalculatorForm from './components/RoiCalculatorForm';
import ResultsDisplay from './components/ResultsDisplay';
import GradientHeader from './components/GradientHeader';
import GradientFooter from './components/GradientFooter';
import BackgroundElements from './components/BackgroundElements';

function App() {
  const [results, setResults] = useState(null);
  const [inputs, setInputs] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const calculateRoi = async (formData) => {
    setIsLoading(true);
    setError(null);
    try {
      // Save the form data to inputs state
      setInputs(formData);
      
      // Update the URL to point to the correct backend endpoint
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
      const response = await fetch(`${apiUrl}/api/calculate-roi`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        // Extract error message from response
        const errorMsg = data.error || 'An unknown error occurred';
        setError(errorMsg);
        setResults(null);
      } else {
        setResults(data);
        setError(null);
      }
      
      setIsLoading(false);
    } catch (error) {
      console.error('Error calculating ROI:', error);
      setError('Failed to connect to the server. Please try again later.');
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setResults(null);
    setError(null);
  };

  return (
    <div className="App">
      <BackgroundElements />
      <GradientHeader />
      
      <main className="main-container">
        <div className="content-container">
          {results === null ? (
            <RoiCalculatorForm onCalculateRoi={calculateRoi} />
          ) : (
            <ResultsDisplay results={results} inputs={inputs} onReset={resetForm} />
          )}
          
          {error && (
            <div className="error-message">
              <p>{error}</p>
              <button onClick={resetForm} className="back-button">
                Back to Calculator
              </button>
            </div>
          )}
          
          {isLoading && (
            <div className="loading-overlay">
              <div className="loading-spinner"></div>
              <p>Calculating your ROI...</p>
            </div>
          )}
        </div>
      </main>
      
      <GradientFooter />
    </div>
  );
}

export default App;
